import { IdHelper } from 'apps/idl/src/helpers';
import { ArrayHelper } from 'apps/idl/src/helpers/arrayHelper';
import { ContactHelper } from 'apps/idl/src/helpers/contactHelper';
import { ObjectHelper } from 'apps/idl/src/helpers/objectHelper';
import { EPrefix } from 'apps/idl/src/model';
import { IContact } from 'apps/idl/src/model/contacts/IContact';
import { IGroup } from 'apps/idl/src/model/contacts/IGroup';
import { ModelMatch } from "apps/idl/src/modules/utils/models/decorators/model-match.decorator";
import { ActeOccurrenceComparator } from "./acte-occurrence-comparator";
import { EOccurrenceType } from './EOccurrenceType';
import { IActeOccurrence } from "./iacte-occurrence";
import { IActeOccurrenceIntervenantsComparatorParams } from "./iacte-occurrence-intervenants-comparator-params";
import { IConstraintLabelParams } from './iconstraint-label-params';

const C_TYPE = EOccurrenceType.intervenants;

@ModelMatch((poData: ActeOccurrenceIntervenantsComparator) => poData?.type === C_TYPE, ActeOccurrenceComparator)
export class ActeOccurrenceIntervenantsComparator extends ActeOccurrenceComparator<IActeOccurrenceIntervenantsComparatorParams> {

	//#region PROPERTIES

	public readonly type: EOccurrenceType = C_TYPE;

	//#endregion

	//#region METHODS

	/** @override */
	public getLabel(poParams: IConstraintLabelParams): string {
		const laIntervenantsAndGroups: Array<IContact | IGroup> = [];

		this.params?.intervenantIds.forEach((psIntervenantId: string) => {
			const loIntervenantOrGroup: IContact | IGroup = poParams.intervenantsAndGroups.find((poContact: IContact) => psIntervenantId === poContact._id);
			if (!ObjectHelper.isNullOrEmpty(loIntervenantOrGroup))
				laIntervenantsAndGroups.push(loIntervenantOrGroup);
		});

		return `${this.params.intervenantIds?.length > 1 ? "des intervenants" : "de l'intervenant"} ${laIntervenantsAndGroups.map((poIntervenantOrGroup: IContact | IGroup) => {
			if (IdHelper.getPrefixFromId(poIntervenantOrGroup._id) === EPrefix.contact)
				return ContactHelper.getCompleteFormattedName(poIntervenantOrGroup as IContact);
			else
				return (poIntervenantOrGroup as IGroup).name;
		}).join(", ")}`;
	}

	/** @override */
	public match(poActeOccurrence: IActeOccurrence): boolean {
		return ArrayHelper.areArraysEqual(poActeOccurrence.intervenantIds, this.params?.intervenantIds);
	}

	/** @override */
	public getIntervenantsIds(): string[] {
		return this.params?.intervenantIds ?? [];
	}

	//#endregion

}
